/* ===================================================================
 * Guia de Medidas — converte conteúdo da página admin em tabs.
 *
 * Espera estrutura HTML no admin do tipo:
 *   <div class="container-guia-medidas">
 *     <div class="item-guia">
 *       <div class="titulo-guia tabela-{slug}">Label</div>
 *       <img src="..." alt="...">
 *     </div>
 *     ...
 *   </div>
 *
 * Comportamento:
 *  - Quando o <x-drawer.drawer--size-guide> abre, monta tabs uma vez.
 *  - Filtra abas só pros tipos disponíveis no produto (data-style-values).
 *  - Pré-seleciona aba conforme variante atual (data-current-style).
 *  - Caso "Infantil": resolve Body vs Camiseta MINI por data-size-values
 *    (presença de "03 meses" → body).
 *  - Sem variante de Estilo: heurística por data-product-title.
 *  - Escuta evento `variant:change` (do tema) — atualiza aba ativa
 *    em tempo real quando user muda variante.
 * =================================================================== */

(function () {
  'use strict';

  // Mapeamento variante "Tipo - Estilo" → slug da tabela.
  // Use lowercase. Use null pra slugs que dependem de tamanho (resolve dinamicamente).
  var TYPE_TO_TABLE = {
    'baby look': 'baby-look',
    'baby look algodão peruano': 'baby-look',
    'baby look algodao peruano': 'baby-look',
    'unissex': 'unissex',
    'unissex algodão peruano': 'unissex',
    'unissex algodao peruano': 'unissex',
    'unissex oversized': 'oversized',
    'oversized': 'oversized',
    'hoodie slim': 'hoodie',
    'moletom hoodie': 'hoodie',
    'moletom capuz': 'hoodie',
    'moletom cropped': 'moletom-cropped',
    'suéter slim': 'sueter',
    'sueter slim': 'sueter',
    'moletom sueter': 'sueter',
    'moletom suéter': 'sueter',
    'cropped': 'cropped',
    'regata': 'regata',
    'infantil': null // null = resolver via tamanho (03 meses → body, senão → infantil)
  };

  // Heurísticas por título do produto (fallback quando produto não tem variante "Tipo - Estilo")
  var TITLE_HEURISTICS = [
    [/body|beb[eê]/i, 'body'],
    [/infantil|mini|crian[çc]a/i, 'infantil'],
    [/moletom cropped/i, 'moletom-cropped'],
    [/cropped/i, 'cropped'],
    [/oversized/i, 'oversized'],
    [/hoodie|moletom capuz/i, 'hoodie'],
    [/su[eé]ter/i, 'sueter'],
    [/baby look/i, 'baby-look'],
    [/regata/i, 'regata'],
    [/unissex/i, 'unissex']
  ];

  function normalize(str) {
    return (str || '').toLowerCase().trim().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function styleToSlug(styleValue, sizeValuesRaw) {
    var key = (styleValue || '').toLowerCase().trim();
    if (!(key in TYPE_TO_TABLE)) return null;
    var slug = TYPE_TO_TABLE[key];
    if (slug !== null) return slug;
    // Caso 'infantil': depende de tamanho
    var sizeN = normalize(sizeValuesRaw);
    if (sizeN.indexOf('03 meses') !== -1 || sizeN.indexOf('3 meses') !== -1) {
      return 'body';
    }
    return 'infantil';
  }

  function titleToSlug(title) {
    if (!title) return null;
    for (var i = 0; i < TITLE_HEURISTICS.length; i++) {
      var entry = TITLE_HEURISTICS[i];
      if (entry[0].test(title)) return entry[1];
    }
    return null;
  }

  function extractItems(containerEl) {
    var items = [];
    var blocks = containerEl.querySelectorAll('.item-guia');
    for (var i = 0; i < blocks.length; i++) {
      var el = blocks[i];
      var titulo = el.querySelector('.titulo-guia');
      var img = el.querySelector('img');
      if (!titulo || !img) continue;

      // Pega a primeira classe que comece com "tabela-"
      var slug = null;
      var classes = titulo.className.split(/\s+/);
      for (var j = 0; j < classes.length; j++) {
        if (classes[j].indexOf('tabela-') === 0) {
          slug = classes[j].substr('tabela-'.length);
          break;
        }
      }
      if (!slug) continue;

      items.push({
        slug: slug,
        label: titulo.textContent.trim(),
        imgSrc: img.getAttribute('src'),
        imgSrcset: img.getAttribute('srcset') || '',
        imgAlt: img.getAttribute('alt') || titulo.textContent.trim()
      });
    }
    return items;
  }

  function setActiveTab(drawer, slug) {
    var root = drawer.querySelector('.size-guide-tabs');
    if (!root) return;
    var tabs = root.querySelectorAll('.size-guide-tabs__tab');
    var panels = root.querySelectorAll('.size-guide-tabs__panel');
    var matched = false;
    for (var i = 0; i < tabs.length; i++) {
      var isMatch = tabs[i].dataset.slug === slug;
      tabs[i].classList.toggle('is-active', isMatch);
      tabs[i].setAttribute('aria-selected', isMatch ? 'true' : 'false');
      if (isMatch) matched = true;
    }
    for (var k = 0; k < panels.length; k++) {
      panels[k].classList.toggle('is-active', panels[k].dataset.slug === slug);
    }
    // Se nada bateu, mantém o primeiro como ativo (fallback safe)
    if (!matched && tabs.length > 0) {
      tabs[0].classList.add('is-active');
      tabs[0].setAttribute('aria-selected', 'true');
      if (panels[0]) panels[0].classList.add('is-active');
    }
  }

  function resolveActiveSlug(drawer, items) {
    var currentStyle = drawer.dataset.currentStyle || '';
    var sizeValuesRaw = drawer.dataset.sizeValues || '';
    var productTitle = drawer.dataset.productTitle || '';

    var activeSlug = null;
    if (currentStyle) {
      activeSlug = styleToSlug(currentStyle, sizeValuesRaw);
    }
    var hasActiveInItems = activeSlug && items.some(function (i) { return i.slug === activeSlug; });
    if (!hasActiveInItems) {
      var hSlug = titleToSlug(productTitle);
      if (hSlug && items.some(function (i) { return i.slug === hSlug; })) {
        activeSlug = hSlug;
      } else {
        activeSlug = items[0] ? items[0].slug : null;
      }
    }
    return activeSlug;
  }

  function buildTabsDOM(items, activeSlug) {
    var root = document.createElement('div');
    root.className = 'size-guide-tabs';

    var nav = document.createElement('nav');
    nav.className = 'size-guide-tabs__nav';
    nav.setAttribute('role', 'tablist');
    nav.setAttribute('aria-label', 'Selecione o tipo de produto');

    var panels = document.createElement('div');
    panels.className = 'size-guide-tabs__panels';

    items.forEach(function (item) {
      var isActive = item.slug === activeSlug;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'size-guide-tabs__tab' + (isActive ? ' is-active' : '');
      btn.dataset.slug = item.slug;
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.textContent = item.label;
      nav.appendChild(btn);

      var panel = document.createElement('div');
      panel.className = 'size-guide-tabs__panel' + (isActive ? ' is-active' : '');
      panel.dataset.slug = item.slug;
      panel.setAttribute('role', 'tabpanel');

      var img = document.createElement('img');
      img.src = item.imgSrc;
      if (item.imgSrcset) img.srcset = item.imgSrcset;
      img.alt = item.imgAlt;
      img.loading = 'lazy';
      panel.appendChild(img);
      panels.appendChild(panel);
    });

    root.appendChild(nav);
    root.appendChild(panels);

    // Listener pra trocar tabs ao clicar
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('.size-guide-tabs__tab');
      if (!btn) return;
      var slug = btn.dataset.slug;
      var allTabs = nav.querySelectorAll('.size-guide-tabs__tab');
      for (var i = 0; i < allTabs.length; i++) {
        var isMatch = allTabs[i].dataset.slug === slug;
        allTabs[i].classList.toggle('is-active', isMatch);
        allTabs[i].setAttribute('aria-selected', isMatch ? 'true' : 'false');
      }
      var allPanels = panels.querySelectorAll('.size-guide-tabs__panel');
      for (var k = 0; k < allPanels.length; k++) {
        allPanels[k].classList.toggle('is-active', allPanels[k].dataset.slug === slug);
      }
    });

    return root;
  }

  function buildTabs(drawer) {
    if (drawer.__sizeGuideTabsBuilt) return;

    var contentRoot = drawer.querySelector('[data-size-guide-content]');
    if (!contentRoot) return;

    var originalContainer = contentRoot.querySelector('.container-guia-medidas');
    if (!originalContainer) return;

    var allItems = extractItems(originalContainer);
    if (allItems.length === 0) return;

    drawer.__sizeGuideTabsBuilt = true;

    // Determinar slugs relevantes pro produto
    var styleValuesRaw = drawer.dataset.styleValues || '';
    var sizeValuesRaw = drawer.dataset.sizeValues || '';
    var productTitle = drawer.dataset.productTitle || '';

    var styleValues = styleValuesRaw ? styleValuesRaw.split('|').filter(Boolean) : [];
    var relevantSlugs = [];

    if (styleValues.length > 0) {
      styleValues.forEach(function (v) {
        var s = styleToSlug(v, sizeValuesRaw);
        if (s && relevantSlugs.indexOf(s) === -1) relevantSlugs.push(s);
      });
    } else {
      // Fallback: heurística por título
      var hSlug = titleToSlug(productTitle);
      if (hSlug) relevantSlugs.push(hSlug);
    }

    // Filtrar tabelas relevantes (preservando ordem da página)
    var filtered = allItems.filter(function (item) {
      return relevantSlugs.indexOf(item.slug) !== -1;
    });

    // Se nenhuma bateu, mostra TUDO (fallback safe pra não ter modal vazio)
    if (filtered.length === 0) filtered = allItems;

    // Salvar filtered no drawer pra re-uso em variant:change
    drawer.__sizeGuideItems = filtered;

    var activeSlug = resolveActiveSlug(drawer, filtered);

    // Construir tabs DOM
    var tabsDOM = buildTabsDOM(filtered, activeSlug);

    // Esconder o original e injetar o novo
    originalContainer.style.display = 'none';
    contentRoot.appendChild(tabsDOM);
  }

  // Pre-build tabs em todos os drawers presentes no DOM (resolve race
  // condition em primeira abertura quando user clica rapido — JS ja
  // tem as tabs construidas quando drawer abre).
  function tryBuildAll() {
    var drawers = document.querySelectorAll('.drawer--size-guide');
    for (var i = 0; i < drawers.length; i++) {
      buildTabs(drawers[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryBuildAll);
  } else {
    tryBuildAll();
  }

  // Listener global como fallback (caso drawer seja injetado posteriormente)
  document.addEventListener('dialog:after-show', function (e) {
    var drawer = e.target;
    if (drawer && drawer.classList && drawer.classList.contains('drawer--size-guide')) {
      buildTabs(drawer);
      // Garantir aba ativa correta na abertura (caso variante tenha mudado antes)
      if (drawer.__sizeGuideItems) {
        var activeSlug = resolveActiveSlug(drawer, drawer.__sizeGuideItems);
        if (activeSlug) setActiveTab(drawer, activeSlug);
      }
    }
  });

  // Listener pra variant:change — atualiza dataset e aba ativa dinamicamente
  document.addEventListener('variant:change', function (e) {
    if (!e.detail || !e.detail.variant) return;
    var detailFormId = e.detail.formId;
    var newVariant = e.detail.variant;

    // Encontrar drawers desse form
    var drawers = document.querySelectorAll('.drawer--size-guide');
    for (var i = 0; i < drawers.length; i++) {
      var drawer = drawers[i];
      if (drawer.dataset.formId !== detailFormId) continue;

      // Ler valor atual da option de Estilo via position
      var stylePos = parseInt(drawer.dataset.stylePosition || '0', 10);
      if (stylePos > 0) {
        var optionKey = 'option' + stylePos;
        var newStyleValue = newVariant[optionKey] || '';
        drawer.dataset.currentStyle = newStyleValue;
      }

      // Se tabs já existem, re-aplicar aba ativa
      if (drawer.__sizeGuideItems) {
        var activeSlug = resolveActiveSlug(drawer, drawer.__sizeGuideItems);
        if (activeSlug) setActiveTab(drawer, activeSlug);
      }
    }
  });
})();
